<template>
    <group-report-template  v-model:current-report-template-id="currentReportTemplateId"
                            v-model:for-group="forGroup"
                            v-model:ran-report="reportSuccessfullySent"
                            v-model:reload-data="reloadTable"
                            v-model:running-errors="errorSending"
                            v-model:running-report="runningReport"
                            v-model:settings="settings"
                            :has-settings="hasManualRunSettings"
                            :hide-title="true"
                            :use-settings-drawer="true"
                            :use-template-cards="true"
                            :use-group-reporting-option="groupReportingEnabled"
                            :on-demand-only="true"
                            :has-run-inputs="false"
                            no-run-inputs-message="This report snapshots the current alarm configuration for every monitoring point you can see. Select Generate Report to run it now."
                            :report-icon="settingsSchema.icon"
                            :schema="settingsSchema"
                            report-name="alarm-configuration-report"
                            v-model:display-section="displaySection"
                            @useStandardReporting="setUseStandardReporting"
    >

        <template   #run-options="props">
            <!-- Nothing to pick: the shared run form renders no inputs, and the
                 page runs the report from its Run Report button (or the run
                 slide-over's footer for a saved template). -->
            <interval-selection :use-meters="false"
                                :footer-mode="props.footerMode ?? 'none'"
                                :is-running="runningReport"
                                :ran-report="reportSuccessfullySent"
                                :running-errors="errorSending ?? []"
                                @run-report="runReport(props.reportTemplateId ?? null)"
            ></interval-selection>
        </template>
    </group-report-template>
</template>

<script>
import {SonicuCoreMixin} from "../../mixins/SonicuCoreMixin";
import {ajaxTableMixin} from "../../mixins/ajaxTableMixin";
import {useGroupReport} from "@/composables/useGroupReport";

import GroupReportTemplate from "./GroupReportTemplate";
import IntervalSelection from "./IntervalSelection";
import alarmConfigSchema from "./settings/schemas/alarm-configuration";

export default {
    name: "GroupAlarmConfigurationReport",
    mixins: [SonicuCoreMixin, ajaxTableMixin],
    components: {
        GroupReportTemplate,
        IntervalSelection,
    },
    props: {
        interval: {
            type: String,
            default: 'monthly',
        },
        defaultSettings: {
            type: Object,
            default() {
                return {}
            }
        },
    },
    setup(props) {
        const report = useGroupReport(alarmConfigSchema, {
            interval: props.interval,
            defaultSettings: props.defaultSettings,
        })

        return {
            ...report,
        }
    },
    computed: {
        settingsSchema() {
            return alarmConfigSchema
        },
    },
}
</script>
